import TextInput from "../../../components/inputs/text-input/text-input";
import useInput from "../hooks/use-input";
import { useFormContext } from "../contexts/form-context";
import { useEffect, useLayoutEffect } from "react";
import { useTranslate } from "../../translation/hooks/use-translation";

const FormTextInput = (props) => {
  const { ref, bind } = useInput(props);

  const { register, deregister, updateValidity } = useFormContext();
  const { getTranslatedProps } = useTranslate();

  const { translatedLabel, translatedPlaceholder } = getTranslatedProps(props);

  useLayoutEffect(() => {
    if (!props.ignore) {
      register(props.id || props.name, ref);

      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);

  return (
    <TextInput
      {...props}
      {...bind}
      label={translatedLabel}
      placeholder={translatedPlaceholder}
    />
  );
};

export default FormTextInput;
